module.exports = __webpack_public_path__ + "static/media/lojinha-home.fb267fed.svg";